module.exports = __webpack_public_path__ + "static/img/roland_ph_01.296fcb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/roland_ph_01.png
// module id = UxPN
// module chunks = 0